import React, { useState, useEffect, useMemo, useContext } from "react";
import axios from "axios";
import { useParams, Link, useNavigate } from "react-router-dom";
import { checkUserPermission } from "../../common/UserPermission";
import config from "../../config/config";
// import DataTable from "react-data-table-component";
import LookupReceiptSaleModal from "../Modal/LookupReceiptSaleModal";
import DeleteConfirmation from "../Modal/DeleteConfirmation";
import Select from "react-select";
import moment from "moment";
//MUI Table
import { MaterialReactTable } from "material-react-table";
import { Box, MenuItem } from "@mui/material";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../common/Constant";
import Loader from "../Loader/Loader";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../DatePicker/CommonDatePicker";
import CommonMatrialReactTableServerSideRender from "../Datatable/CommonMatrialReactTableServerSideRender";
import CommonMatrialReactTable from "../Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../common/CurrencySymbol";
import { AppContext } from "../../context/AppContext";
import ReportDate from "../Reports/ReportDate";

let PERMISSION_EDIT = "/manage-customers/:id";
let PERMISSION_DELETE = "delete-customers";

const Customerlisting = ({ listid, customerid, Model = false, customerType }) => {
  const { CurrencySymbol, FractionDigits } = useContext(AppContext);
    const { isManageSale, isManagePOSSale } = useContext(AppContext);
  const options = [
    { label: "All", value: 1 },
    { label: "Custom", value: 2 },
    { label: "Last Week", value: 3 },
    { label: "Current Week", value: 4 },
    { label: "Last Month", value: 5 },
    { label: "Current Month", value: 6 },
    { label: "Last 7 Day", value: 7 },
  ];
  const startLast7DayDate = moment()
    .subtract(6, "days")
    .startOf("day")
    .format("YYYY-MM-DD");
  const endLast7DayDate = moment().endOf("day").format("YYYY-MM-DD");

  const today = moment().format("YYYY-MM-DD");
  const [data, setData] = useState([]);
  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [isFirstTimeCall, setIsFirstTimeCall] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageSize, setperPageSize] = useState(25);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [sortingId, setSortingId] = useState(3);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedSalesCheckboxIds, setselectedSalesCheckboxIds] = useState("");
  const [startingDate, setStartingDate] = useState(""); //startLast7DayDate
  const [selectReport, setSelectReport] = useState(1);
  const [selectedDate, setSelectedDate] = useState([]);
  const [endingDate, setEndingDate] = useState(""); //endLast7DayDate
  const [salesTypeID, setSalesTypeID] = useState(0);
  const [customerID, setCustomerID] = useState(0);
  const [customerList, setCustomerList] = useState([]);
  const [subCustomerId, setSubCustomerId] = useState(0);
  const paramObject = useParams();
  const token = localStorage.getItem("Token");
  const [pagenumber, setPageNumber] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const [filtertext, setFilterText] = useState("");
  const [ordercolumn, setOrderColumn] = useState("");
  const [currentorder, setCurrentOrder] = useState("");
  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();
  const [columnVisibility, setColumnVisibility] = useState({
    PaymentType: false,
    // SyncStatus: false,
    Balance: false,
    CreditUsed: false,
    // AmountDue:false,
    DueDate: false,
  });
  const [columnOrder, setColumnOrder] = useState([]);
  const [saletype, setSaletype] = useState([]);
  const [salesTypeValue, setSalesTypeValue] = useState();

  let salesTypeDropdownOption = [];
  const SalesTypeDropdown = saletype.map((u, i) => {
    salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
  });

  const [nemultiselect, setnemultiselect] = useState({
    SaleType: [],
  });

  const handleChangeSalesType = (event) => {
    // setSalesTypeValue(event);
    setSalesTypeID(event?.value);
  };


  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const deleteRequestParam = localStorage.getItem("DeleteRequestParam");

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  console.log(sorting, "4444");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 150,
  });

  console.log(pagination,"paginationcheck");

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });
  }, []);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setStartingDate("");
      setEndingDate("");
    }
  };

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    // if (selectReport != 2){
      setStartingDate(payload);
      setEndingDate(enddate2);
    // }

    console.log("enddate =>", enddate2);
  };

  // useEffect (() => {
  //   toastError("call dates")
  //   if (selectReport != 2) {
  //   handleListData(
  //     1,
  //     perPageSize,
  //     searchtext,
  //     sortingId,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     salesTypeID,
  //     customerid,
  //     columnFilters,
  //     globalFilter,
  //     // pagination,
  //     sorting
  //   );
  //   }
  // },[startingDate,endingDate])

  const handleChangeCustomStartingDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      // const datetime =
      //   moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
      // const settime = moment(datetime).format("YYYY-MM-DD");
      // console.log(settime, "settime");
      setCustomStartingDate(selectedDate);
      setStartingDate(selectedDate);
    }
  };

  const handleSearchAccordingToDate = () => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      salesTypeID,
      customerid,
      columnFilters,
      globalFilter,
      // pagination,
      sorting
    );
  };
  // const handleChangeCustomEndingDate = (event) => {
  //   setCustomEndingDate(event.target.value);
  //   setEndingDate(event.target.value);
  // };

  // const handleChangeCustomEndingDate = (selectedDate) => {
  //   if (selectedDate && selectedDate.length > 0) {
  //     // const datetime =
  //     //   moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
  //     // const settime = moment(datetime).format("YYYY-MM-DD");
  //     // console.log(settime, "settime");
  //     setCustomEndingDate(selectedDate);
  //     setEndingDate(selectedDate);
  //   }
  // };

  // const handleQuickBookChange = (event) => {
  //   setQuickBookOptions(event);

  //   // All Condition
  //   if (event?.value == 1) {
  //     setStartingDate("");
  //     setEndingDate("");
  //   }
  //   // Custom Condition
  //   else if (event?.value == 2) {
  //     setStartingDate(customStartingDate);
  //     setEndingDate(customEndingDate);
  //   }
  //   // Last Week Condition
  //   else if (event?.value == 3) {
  //     const lastWeekStartDate = moment()
  //       .subtract(1, "week")
  //       .startOf("week")
  //       .format("YYYY-MM-DD");
  //     const lastWeekEndDate = moment()
  //       .subtract(1, "week")
  //       .endOf("week")
  //       .format("YYYY-MM-DD");

  //     setStartingDate(lastWeekStartDate);
  //     setEndingDate(lastWeekEndDate);
  //   }
  //   // Current Week Condition
  //   else if (event?.value == 4) {
  //     const lastWeekStartDate = moment().startOf("week").format("YYYY-MM-DD");
  //     const lastWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

  //     setStartingDate(lastWeekStartDate);
  //     setEndingDate(lastWeekEndDate);
  //   }
  //   // Last Month Condition
  //   else if (event?.value == 5) {
  //     const lastMonthStartDate = moment()
  //       .subtract(1, "month")
  //       .startOf("month")
  //       .format("YYYY-MM-DD");
  //     const lastMonthEndDate = moment()
  //       .subtract(1, "month")
  //       .endOf("month")
  //       .format("YYYY-MM-DD");

  //     setStartingDate(lastMonthStartDate);
  //     setEndingDate(lastMonthEndDate);
  //   }
  //   // Current Month Condition
  //   else if (event?.value == 6) {
  //     const firstdate = moment().startOf("month").format("YYYY-MM-DD");
  //     const lastdate = moment().endOf("month").format("YYYY-MM-DD");

  //     setStartingDate(firstdate);
  //     setEndingDate(lastdate);
  //   } else if (event?.value == 7) {
  //     setStartingDate(startLast7DayDate);
  //     setEndingDate(endLast7DayDate);
  //   } else {
  //     setStartingDate("");
  //     setEndingDate("");
  //   }
  // };

  const handleDeletePopup = (pID) => {
    const deleteRequestParam = {
      saleids: pID || selectedSalesCheckboxIds,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
  };

  let column1 = useMemo(() => [
    {
      header: "Transaction Date",
      accessorKey: "TransactionDate",
      Cell: ({ row }) => {
        return moment(row.original.TransactionDate).format("YYYY-MM-DD");
      },
    },
    {
      header: "Sale Type",
      accessorKey: "SaleType",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
    },
    {
      header: "Location",
      accessorKey: "Location",
    },
    {
      header: "Created Date",
      accessorKey: "CreatedDate",
      Cell: ({ row }) => {
        return moment(row.original.CreatedDate).format("YYYY-MM-DD");
      },
    },
    {
      header: "CR/DR",
      accessorKey: "TransactionType",
      Cell: ({ row }) =>
        row.original.TransactionType == "Credit" ? (
          <Box
            // class="text-warning word-break-data"
            // to={`/manage-suppliers/${row.original.SupplierId}`}
            component="span"
            sx={(theme) => ({
              // backgroundColor: '#E8F7F5',
              borderRadius: "0.3rem",
              color: "var(--success-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.StatusName}
          </Box>
        ) : (
          row.original.TransactionType ==
          "Debit"(
            <Box
              component="span"
              sx={(theme) => ({
                // backgroundColor: '#FBECF0',
                borderRadius: "0.3rem",
                color: "#E5AAB7",
                maxWidth: "9ch",
                p: "0.3rem",
                fontWeight: "bold",
              })}
            >
              {row.original.TransactionType}
            </Box>
          )
        ),
    },
  ]);

  let column2 = useMemo(() => [
    {
      header: "Sale/Tran ID",
      accessorKey: "ID",
      filterFn: "contains",
      size:150,
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={(theme) => ({
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          })}
          onClick={() => {
            if (row.original.StatusName === "Opening Balance") {
              navigate(`/manage-customers/${row.original.ID}`);
            } else if (
              row.original.SaleType === "Receive Payment" &&
              row.original.StatusName !== "Sale Deleted"
            ) {
              navigate(`/receive-payment/${row.original.ID}`);
            } else if (row.original.SaleType == "Journal Entry") {
              navigate(`/journal-entry/${row.original.ID}`);
            } else if (row.original.SaleType == "Deposit") {
              navigate(`/bank-deposit/${row.original.ID}`);
            } else if (row.original.SaleType == "Expense") {
              navigate(`/Expense/${row.original.ID}`);
            }  else if (
              (row.original.SaleType === "Sale" ||
                "Estimate" ||
                "Return / Memo") &&
              row.original.StatusName !== "Sale Deleted"
            ) {
              navigate(`/sales-receipt/${row.original.InvoiceNo}`);
            }
          }}
        >
          <span
                style={{
                  display: "inline-block",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor:
                     row.original.SyncStatus == "Complete"
                ? "var(--success-main-color)"
                : ((row.original.SyncStatus == "Failed") && (row.original.StatusName !== "Opening Balance"))
                ? "var(--error-main-color)"
                : "",
                  marginRight: "8px",
                }}
              ></span>
          {row.original.SaleType === "Sale"
            ? row.original.InvoiceNo
            : row.original.ID}
        </Box>
      ),
    },
    {
      header: "Quickbook SyncStatus",
      accessorKey: "SyncStatus",
      size : 140,
      Cell: ({ row }) => {
        if (row.original.SyncStatus === "Complete") {
          return (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "var(--success-main-color)",
                maxWidth: "9ch",
                p: "0.3rem",
                fontWeight: "bold",
              })}
            >
              {row.original.SyncStatus}
            </Box>
          );
        } else if (
          row.original.SyncStatus === "Failed" &&
          row.original.StatusName !== "Opening Balance"
        ) {
          return (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "var(--error-main-color)",
                maxWidth: "9ch",
                p: "0.3rem",
                fontWeight: "bold",
              })}
            >
              {row.original.SyncStatus}
            </Box>
          );
        } else if (row.original.StatusName === "Opening Balance") {
          return <span>{row.original.StatusName}</span>;
        } else {
          return null; // Handle other cases if necessary
        }
      },
    },
    {
      header: "Date",
      accessorKey: "Date",
      size: 120,
      Cell: ({ row }) => {
        return moment(row.original.Date).format("MM/DD/YYYY");
      },
    },
    {
      header: "Type",
      accessorKey: "SaleType",
      size: 120,
      filterSelectOptions: nemultiselect?.SaleType, // ["paid", "unpaid"],
      filterVariant: "multi-select", //"select",
      enableColumnFilterModes: false,
      Cell: ({ row }) => {
        return row.original.SaleType == null ? "" : row.original.IsCheck == 1 ? "Check" : row.original.IsCC_Credit == 1 ? "Credit Card Credit" : row.original.SaleType;
      },
    },
    {
      header: "No",
      accessorKey: "InvoiceNo",
      size: 110,
      Cell: ({ row }) => {
        return row.original.InvoiceNo == 0 ? "" : row.original.InvoiceNo;
      },
    },
    {
      header: "Method", // "Payment Type",
      accessorKey: "PaymentType",
      size: 130,
      Cell: ({ row }) => {
        return row.original.PaymentType == null ? "" : row.original.PaymentType;
      },
    },
    {
      header: "Memo",
      accessorKey: "Memo",
      size: 110,
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      size: 120,
      Cell: ({ row }) =>
        row.original.DueDate
          ? moment(row.original.DueDate).format("MM/DD/YYYY")
          : "",
    },

    
    // {
    //   header: "Paid Amount",
    //   accessorKey: "AmountPaid",
    //   Cell: ({ row }) => {
    //     return (
    //       <div>
    //         {CurrencySymbols(
    //           Number(row.original.AmountPaid == null ? 0 : row.original.AmountPaid ), 
    //           { CurrencySymbol },   
    //           FractionDigits  
    //         )}
    //       </div>
    //     );
    //   },
    // },
    {
      header: "Balance",
      accessorKey: "AmountDue",
      Cell: ({ row }) => {
        return (
          <div>
            {CurrencySymbols(
              Number(row.original.AmountDue == null ? 0 : row.original.AmountDue ), 
              { CurrencySymbol },   
              FractionDigits  
            )}
          </div>
        );
      },
    },  
    {
      header: "Amount",
      accessorKey: "Payment",
      size: 120,
      Cell: ({ row }) => {
        return (
          <>
             {CurrencySymbols(
              Number(row.original.Payment == null ? 0 : row.original.Payment ), 
              { CurrencySymbol },   
              FractionDigits  
            )}
            {/* ${Number(row.original.Payment).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} */}
          </>
        );
      },
    },
    // {
    //   header: "Credit Used",
    //   accessorKey: "CreditUsed",
    //   Cell: ({ row }) => 
    //     row.original.CreditUsed != null
    //       ? `$${Number(row.original.CreditUsed).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    //       : "$0.00",
    // },
    
    {
      header: "Status",
      accessorKey: "StatusName",
       size: 110,
      Cell: ({ row }) => {
        const status = row.original.StatusName || "";
        return (
          <>
            {status === "Closed" || status === "Paid" && (
              <i className='fas fa-check-circle fs-4 me-2' style={{ color: 'green' }}></i>
            )}
            {status.includes("Overdue") && (
              <i className='fas fa-exclamation-circle fs-4 me-2' style={{ color: 'orange' }}></i>
            )}
            {status}
            {row.original.Credit == 0 ? (
              ""
            ) : (
              <>
                <br />
                Credit: 
                {/* ${parseFloat(row.original.Credit).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} */}
                {CurrencySymbols(
              Number(row.original.Credit == null ? 0 : row.original.Credit ), 
              { CurrencySymbol },   
              FractionDigits  
            )}
              </>
            )}
          </>
        );
      },
    },
    {
      header: "Open Balance",
      accessorKey: "Balance",
      size: 130,
      // Cell: ({ row }) => 
      //   row.original.Balance != null
      //     ? `$${Number(row.original.Balance).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      //     : "$0.00",
      Cell: ({ row }) => {
        return (
          <div>
            {CurrencySymbols(
              Number(row.original.Balance), 
              { CurrencySymbol },   
              FractionDigits  
            )}
          </div>
        );
      },
    },
    {
      header: "Last Modified",
      accessorKey: "LatestDate",
      size: 160,
      // size: 130,
      Cell: ({ row }) => { 
        return row.original.StatusName == "Opening Balance"
        ? "" :  row.original.LatestDate
        ? moment(row.original.LatestDate).format('MM/DD/YYYY h:mm A') 
        : ""
      },
    },
    
  ]);

  const contextActions = useMemo(() => {
    const handleDeletePopup = (pID) => {
      const deleteRequestParam = {
        saleids: selectedSalesCheckboxIds,
      };
      localStorage.setItem(
        "DeleteRequestParam",
        JSON.stringify(deleteRequestParam)
      );
    };

    return (
      <button
        type="button"
        className="btn btn-danger btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Delete
      </button>
    );
  }, [selectedRows, toggleCleared]);

  useEffect(() => {
    // setLoading(true);

    if (selectReport != 2) {
    handleListData(
      1,
      perPageSize,
      filtertext,
      ordercolumn,
      currentorder,
      startingDate,
      endingDate,
      salesTypeID,
      customerid,
      columnFilters,
      globalFilter,
      // pagination,
      sorting
    );
  }
    // }
  }, [
    listid,
    salesTypeID,
    customerid,
    // quickBookOptions,
    sorting,
    pagination.pageIndex,
    pagination.pageSize,
    globalFilter,
    columnFilters,
    subCustomerId,
    startingDate,endingDate
  ]);

  // useEffect(() => {
  //   axios
  //     .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
  //       headers: {
  //         "Content-Type": "application/json;charset=UTF-8",
  //         Authorization: token,
  //       },
  //     })
  //     .then((response) => {
  //       setSaletype(response.data.ResponseData);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }, []);

  useEffect(() => {
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/getalltransactiontype?isshowviewregister=3`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const transactionType = res.data.ResponseData.map((u) => ({
          label: u.Name,
          value: u.ID,
        }));
        setSaletype(transactionType);
        console.log("res280", res.data.ResponseData);
      });

      CustomerAPI();

  }, []);

    const CustomerAPI = () => {
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const customerOption = res.data.ResponseData.map((u) => ({
          // label: `${u.CompanyName} -- (${u?.CustomerType})`,
          label: `${u.CompanyName} (${u.FirstName} ${u.LastName}) - ${u.Id == paramObject.id ? "Parent" : "Sub"} Customer`,
          value: u.Id,
          ParentCustomerId: u.ParentCustomerId,
          // quickbookid: u.QuickbookID,
          // Balance: u.Balance,
        }));
        setCustomerList(customerOption);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    startdate,
    enddate,
    saletypeid,
    customerid,
    columnFilters,
    globalFilter,
    // pagination,
    sorting,
    status
  ) => {
    console.log(sorting, "111");

    saletypeid = saletypeid > 0 ? saletypeid : 0;
    customerid = customerid > 0 ? customerid : 0;
    let columnIndex;
    salesTypeID === 4
      ? (columnIndex = column1.findIndex(
          (column) => column.accessorKey === sorting[0]?.id
        ))
      : (columnIndex = column2.findIndex(
          (column) => column.accessorKey === sorting[0]?.id
        ));

    const FilterColumnText = {};
    // FilterColumnText.filtercolumntext = columnFilters;
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    setLoading(true);
    axios
      .get(
        `${
          config.customersBaseUrl
        }/customers/customertransactionlist?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc == true
            ? "desc"
            : "asc"
        }&ordercolumn=${sorting[0]?.id ? sorting[0]?.id : ""}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate === undefined ? "" : startdate}&enddate=${
          enddate === undefined ? "" : enddate
        }&salestypeid=${saletypeid}&customerid=${customerid}&LocationID=${localStorage.getItem(
          "Location"
        )}&status=${status == undefined ? 0 : "status"}&isFirstTimeCall=${isFirstTimeCall}&subCustomerId=${subCustomerId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setIsFirstTimeCall(0);
        setData(res.data.ResponseData);
        const data = res.data.ResponseData;
        setnemultiselect({
          SaleType: [...new Set(data?.map((item) => item?.SaleType))],
        });
        setTotalRows(res.data.ResponseData[0]?.TotalRecords);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   if (quickBookOptions?.value == 1) {
  //     setStartingDate('');
  //     setEndingDate('');
  //   } else if (quickBookOptions?.value == 3) {
  //     const lastWeekStartDate = moment()
  //       .subtract(1, "week")
  //       .startOf("week")
  //       .format("YYYY-MM-DD");
  //     const lastWeekEndDate = moment()
  //       .subtract(1, "week")
  //       .endOf("week")
  //       .format("YYYY-MM-DD");

  //     setStartingDate(lastWeekStartDate);
  //     setEndingDate(lastWeekEndDate);
  //   }
  //   // Current Week Condition
  //   else if (quickBookOptions?.value == 4) {
  //     const currentWeekStartDate = moment()
  //       .startOf("week")
  //       .format("YYYY-MM-DD");
  //     const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

  //     setStartingDate(currentWeekStartDate);
  //     setEndingDate(currentWeekEndDate);
  //   }
  //   // Last Month Condition
  //   else if (quickBookOptions?.value == 5) {
  //     const lastMonthStartDate = moment()
  //       .subtract(1, "month")
  //       .startOf("month")
  //       .format("YYYY-MM-DD");
  //     const lastMonthEndDate = moment()
  //       .subtract(1, "month")
  //       .endOf("month")
  //       .format("YYYY-MM-DD");

  //     setStartingDate(lastMonthStartDate);
  //     setEndingDate(lastMonthEndDate);
  //   }
  //   //currentmonth
  //   else if (quickBookOptions?.value == 6) {
  //     const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
  //     const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

  //     setStartingDate(currentFirstDate);
  //     setEndingDate(currentLastDate);
  //   } else if (quickBookOptions?.value == 7) {
  //     setStartingDate(startLast7DayDate);
  //     setEndingDate(endLast7DayDate);
  //   } else {
  //     setStartingDate(today);
  //     setEndingDate(today);
  //   }
  // }, [quickBookOptions]);

  // const sortData = data?.sort((a, b) => {
  //   return a?.row_num - b?.row_num;
  // });

  const renderRowActionMenuItems = ({ row, closeMenu }) =>
    listid === 4
      ? false
      : ({ row }) => [
          checkUserPermission() ? (
            <MenuItem
              key="edit"
              onClick={() =>
                navigate(
                  isManageSale == 1
                    ? `/manage-sales/${row.original.ID}`
                    : isManagePOSSale == 1
                    ? `/pos/${row.original.ID}`
                    : "#"
                )
                 
                // navigate(`/manage-sales/${row.original.ID}`)
            }
            >
              Edit
            </MenuItem>
          ) : (
            ""
          ),
          <MenuItem
            className="confirm-text"
            to="#"
            // key="delete"
            title="Delete"
            data-bs-toggle="modal"
            data-bs-target="#DeleteConfirmationModal"
            onClick={() => handleDeletePopup(row.original.ID)}
          >
            Delete
          </MenuItem>,
        ];

  return (
    <>
      {/* Invoice data */}
      <Loader loading={loading} />
      <div className={"col-lg-12 col-md-12"}>
        <div className="card bg-white">
          {!Model && (
            <>
              <div className="d-flex justify-content-between mt-3 mr-3">
                <h5 className="card-title ml-3 mt-3">Transaction</h5>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-dark"
                  style={{ borderRadius: "5px", padding: "8px" }}
                  onClick={() => navigate("/customers")}
                >
                  Back
                </button>
              </div>
              <hr />
            </>
          )}
          <div className="d-flex w-100 ml-2  ml-3">
            {/* mt-2 */}
            <div className="p-1 col-lg-3 col-md-6 col-sm-12">
              <label className="col-form-label col-md-12 form-label p-lg-medium"> Date Filter: </label>
              {/* <Select
                defaultValue={quickBookOptions}
                onChange={(event) => {
                  handleQuickBookChange(event);
                }}
                options={options}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                // isClearable={true}
                // hideSelectedOptions={true}
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                className="custom-search-select"
              /> */}
              <Select
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                options={reportdropdown}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                hideSelectedOptions={true}
                // isClearable={true}
                name="Reportperiod"
                id="Reportperiod"
                value={reportdropdown.find((e) => e.value === selectReport)}
                onChange={(event) => {
                  handleDropdownChange(event);
                }}
                className="custom-search-select"
              ></Select>
            </div>
             {selectReport !== 1 && (
              <div className="col-sm-4 ms-4">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            {/* {quickBookOptions?.value == 2 && (
              <>
                <div className="p-1 col-lg-2 col-md-6 col-sm-12">
                  Start Date:
                  <CommonDatePicker
                    FinalDate={startingDate}
                    handleDateChange={handleChangeCustomStartingDate}
                  />
                </div>
                <div className="p-1 col-lg-2 col-md-6 col-sm-12">
                  End Date:
                  <CommonDatePicker
                    FinalDate={endingDate}
                    handleDateChange={handleChangeCustomEndingDate}
                  />
                </div>
              </>
            )} */}
            {selectReport == 2 && (
              <>
              <div className="p-1 col-lg-1 col-md-6 col-sm-12">
              <label className="col-form-label col-md-12 form-label p-lg-medium"> {" "} </label>
                <button
                  className="btn btn-primary mt-3"
                  onClick={() => handleSearchAccordingToDate()}
                >
                  {" "}
                  Search{" "}
                </button>
              </div>
              </>
            )}

            <div className="p-1 col-lg-3 col-md-6 col-sm-12">
              <label className="col-form-label col-md-12 form-label p-lg-medium">Transaction Type:</label>
              <Select
                // defaultValue={salesTypeValue}
                onChange={(event) => {
                  handleChangeSalesType(event);
                }}
                // options={salesTypeDropdownOption}
                options={saletype}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                isClearable={true}
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                className="custom-search-select "
              />
            </div>

            {customerType == 1 && (
            <div className="p-1 col-lg-3 col-md-6 col-sm-12">
              Sub Customer:
              <Select
                options={customerList.filter(el => el.ParentCustomerId == paramObject.id || el.value == paramObject.id)}
                onChange={(event) => {
                  setSubCustomerId(event ? event.value : 0);
                }}
                placeholder="Select Sub Customer"
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                isClearable={true}
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                className="custom-search-select "
              />
            </div>
            )}
          </div>

          <div
            className="card-body"
            style={{ position: "relative", zIndex: "0" }}
          >
            {/* <MaterialReactTable
              columns={salesTypeID === 4 ? column1 : column2}
              data={sortData}
              enableColumnResizing
              enableGrouping
              enableStickyHeader
              enableStickyFooter
              // enableRowSelection={salesTypeID === 4 ? false : true}
              enableColumnOrdering
              initialState={{
                density: "comfortable",
                expanded: true, //expand all groups by default
                // grouping: [""], //an array of columns to group by by default (can be multiple)
                pagination: { pageIndex: 0, pageSize: 25 },
                // sorting: [{ id: "state", desc: false }], //sort by state by default
                columnVisibility: {
                  PaymentType: false,
                  SyncStatus:false,
                  Balance:false,
                  CreditUsed:false,
                  // AmountDue:false,
                  DueDate:false,
                  
                },
              }}
              muiTableBodyProps={{
                sx: () => ({
                  "& tr:nth-of-type(even)": {
                    backgroundColor: "rgb(237 237 233 / 63%)",
                  },
                }),
              }}
              muiPaginationProps={{
                rowsPerPageOptions: [25, 50, 100, 300, 500],
              }}
              // For providing color to header of table
              muiTableHeadCellProps={{
                sx: (theme) => ({
                  background: "#e9e9e9",
                  borderRight: "1px solid rgba(224,224,224,1)",
                }),
              }}
              muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
              // manualFiltering
              manualPagination
              manualSorting
              muiToolbarAlertBannerProps={
                isError
                  ? {
                      color: "error",
                      children: "Error loading data",
                    }
                  : undefined
              }
              // onColumnFiltersChange={setColumnFilters}
              onGlobalFilterChange={setGlobalFilter}
              onPaginationChange={setPagination}
              onSortingChange={setSorting}
              rowCount={totalRows}
              state={{
                // columnFilters,
                globalFilter,
                isLoading,
                pagination,
                showAlertBanner: isError,
                showProgressBars: isRefetching,
                sorting,
              }}
              renderRowActionMenuItems={
                listid === 4
                  ? false
                  : ({ row }) => [
                      checkUserPermission() ? (
                        <MenuItem
                          key="edit"
                          onClick={() =>
                            navigate(`/manage-sales/${row.original.ID}`)
                          }
                        >
                          Edit
                        </MenuItem>
                      ) : (
                        ""
                      ),
                      <MenuItem
                        className="confirm-text"
                        to="#"
                        // key="delete"
                        title="Delete"
                        data-bs-toggle="modal"
                        data-bs-target="#DeleteConfirmationModal"
                        onClick={() => handleDeletePopup(row.original.ID)}
                      >
                        Delete
                      </MenuItem>,
                    ]
              }
            /> */}

            <CommonMatrialReactTableServerSideRender
                  MainHeading="Sonar POS"
                  ReportHeading="Customer Transaction"
                  columns={salesTypeID === 4 ? column1 : column2}
                  data={data}
                  // startdate={startdate}
                  // enddate={enddate}
                  columnGrouping={[]}
                  columnsVisibility={{}}
                  enableRowActions={false}
                  enableRowSelection={false}
                  renderRowActionMenuItems={renderRowActionMenuItems}
                  renderTopToolbarCustomActions={({ table }) => (<div></div>)}
                  density="compact"
                  showGlobalFilter={true}
                  showColumnFilters={false}
                  expanded={true}
                  pagination={{ pageIndex: 0, pageSize: 150 }}
                  rowCount={totalRows}
                  setColumnFilters={setColumnFilters} // for termp comment filteron column
                  setGlobalFilter={setGlobalFilter}
                  setPagination={setPagination}
                  setSorting={setSorting}
                  setColumnOrder={setColumnOrder}
                  setColumnVisibility={setColumnVisibility} //setColumnVisibility
                  columnPinning={{}} //{ left: ['CustomerName'], right:['SyncStatusName'] }
                  state={{
                    columnFilters, // for termp comment filteron column
                    // globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                    columnOrder,
                    columnVisibility,
                  }}
                />
            {/* <CommonMatrialReactTable
              MainHeading="Sonar POS"
              ReportHeading="Customer Transaction"
              columns={salesTypeID === 4 ? column1 : column2}
              data={sortData}
              startdate={startingDate}
              enddate={endingDate}
              columnGrouping={[]}
              columnsVisibility={{
                PaymentType: false,
                SyncStatus: false,
                Balance: false,
                CreditUsed: false,
                // AmountDue:false,
                DueDate: false,
              }}
              hodiExport={true}
            /> */}
          </div>
        </div>
      </div>

      <DeleteConfirmation
        deleteApiUrl={`${config.salesconfigBaseUrl}/sales/batchdelete`}
      />
      <LookupReceiptSaleModal />
    </>
  );
};

export default Customerlisting;
